/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './ActionTypes';
import { handleCommaSeparatedAmount } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const axiosPayLoad = {
  suspendedCheckTabObj: {},
  errorMessagesInRedux: [],
  suspendedCheckLogGridList: [],
  invoiceGridList: [],
  reconciliationGridList: [],
  saveOrUpdateMessage: '',
  creditBalanceCount: {},
  unallocatedBalance: {},
  perMfgInvGridList: [],
};
let tempObj = [];
const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.SUSPENDED_CHECK_TAB_DATA:
      return { ...state, suspendedCheckTabObj: action.suspendedCheckTabObj };
    case actionTypes.HANDLE_ERROR_MESSAGE_FOR_SUP_CHECK:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    case actionTypes.GET_SUSPENDED_CHECK_LOG_GRID_LIST:
      if (action.suspendedCheckLogGridList?.length > 0) {
        tempObj = action.suspendedCheckLogGridList?.map((item) => {
          if (!item.checkAmt?.toString()?.includes('$'))
            item.checkAmt = item.checkAmt
              ? handleCommaSeparatedAmount(item.checkAmt)
              : `$ ${parseFloat(0).toFixed(2)}`;
          if (!item.totAllocatedAmt?.toString()?.includes('$'))
            item.totAllocatedAmt = item.totAllocatedAmt
              ? handleCommaSeparatedAmount(item.totAllocatedAmt)
              : `$ ${parseFloat(0).toFixed(2)}`;
          if (!item.beginingBalance?.toString()?.includes('$'))
            item.beginingBalance = item.beginingBalance
              ? handleCommaSeparatedAmount(item.beginingBalance)
              : `$ ${parseFloat(0).toFixed(2)}`;
          if (!item.endingBalance?.toString()?.includes('$'))
            item.endingBalance = item.endingBalance
              ? handleCommaSeparatedAmount(item.endingBalance)
              : `$ ${parseFloat(0).toFixed(2)}`;
          item.suspendedDt = item.suspendedDt
            ? moment(item.suspendedDt).format('MM/DD/YYYY')
            : null;
          return item;
        });
      } else {
        tempObj = [];
      }
      return { ...state, suspendedCheckLogGridList: tempObj };
    case actionTypes.GET_INVOICE_GRID_LIST:
      return { ...state, invoiceGridList: action.invoiceGridList };
    case actionTypes.GET_RECONCILIATION_GRID_LIST:
      return {
        ...state,
        reconciliationGridList: action.reconciliationGridList,
      };
    case actionTypes.FETCH_CREDIT_BALANCE_COUNT:
      return { ...state, creditBalanceCount: action.creditBalanceCount };
    case actionTypes.FETCH_UNALLOCATED_BALANCE:
      return { ...state, unallocatedBalance: action.unallocatedBalance };
    case actionTypes.SAVE_OR_UPDATE_SUSPENDED_CHECKS:
      return { ...state, saveOrUpdateMessage: action.saveOrUpdateMessage };
    default:
      return state;
  }
};

export default reducer;
